export interface SelectedTicketInfo {
  timeSlot?: ValueId;
  rate: ValueId;
  quantity: number;
  ageRangeId: string;
}

export interface ValueId {
  value?: string;
  id: string;
}

export interface ActivityTicket extends SelectedTicketInfo {
  code: string;
  dateOffset: number;
}

export interface ActivityToBook {
  code: string;
  date: Date;
  tickets: SelectedTicketInfo[];
}

export enum BannerActivity {
  Legoland = 'legoland',
  Disneyland = 'disneyland',
}
